// The zone's words from docs/launch/open-haunt.md (launch-copy.ts keeps them verbatim). Two changes for a player
// page: "How it works" loses its CLI commands (they live in the guide and on /developers), and the pumpkin block
// drops its Fortnite aside.

import { HAUNT_FREE, HAUNT_HERO, HAUNT_HOW as HOW, HAUNT_OPEN, HAUNT_PUMPKIN as PUMPKIN, HAUNT_RULES as RULES, type Block } from "../../launch-copy.ts";

export { HAUNT_FREE, HAUNT_HERO, HAUNT_OPEN };

/** The rules, with the one file-format word a player page doesn't use ("GLB") said plainly. */
export const HAUNT_RULES = RULES.map((r) => ({ ...r, list: r.list.map((t) => t.replace("Static only for now: a GLB, its textures and a manifest.", "Static only for now: a 3D model, its textures and a manifest.")) }));

/** The guide's gate (launch-copy.ts HAUNT_HERO's template button). */
export const GUIDE_GATE = "[[?guide-public|yes]]";

/** Drops a sentence that names a command in backticks (`thrdm deploy`): the page keeps the sentence before it. */
export function withoutCommands(s: string): string {
  return s
    .split(/(?<=\.)\s+/)
    .filter((part) => !/`[^`]+`/.test(part))
    .join(" ");
}

export const HAUNT_HOW: Block = { ...HOW, steps: HOW.steps!.map(withoutCommands) };
export const HAUNT_PUMPKIN: Block = { ...PUMPKIN, paras: PUMPKIN.paras!.filter((p) => !/Fortnite/.test(p)) };
